module.exports = __webpack_public_path__ + "static/img/bootstrap4.606453b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/technology/bootstrap4.png
// module id = ijkH
// module chunks = 0